export function selectPresenceByUserId(state, userId) {
  if (userId == null) return null;
  return state.presence?.byUserId?.[String(userId)] || null;
}
